import React from "react";

export default function Home() {
  return (
    <div className="bg-cool p-10 b text-left rounded">
      <img src="rani.jpg" alt="Me" className="w-full rounded-sm h-full"></img>
      {/* <img src="rah.jpeg" alt="Me" className="w-full h-full rounded-sm"></img> */}
      <br></br>
      {/* <h2 className="text-blue-600">---</h2> */}
      <p className="text-xl mt-2">Currently interested in quantum procrastination & deadline manipulation, 
      copy-paste driven development, force push and pray, 
      strategic caffeination, comprehensive comprehension, and ducks 
      (those quacky bread-loving water birds).</p>
      {/* <p className="text-xl mt-2"> */}
      {/*   I tend to dabble in all sorts of */}
      {/*   tech fields and wear many hats. I like to enrich my knowledge in the */}
      {/*   computer-related world, play video-games and chess, and listen to peak */}
      {/*   music. */}
      {/* </p> */}
    </div>
  );
}
